/**
 * Configuration constants for mobile summary cell layout.
 *
 * The mobile summary collapses the first N columns into a single cell
 * with a stacked layout: row 1 shows the first column full-width,
 * row 2 shows columns 2 and 3 side by side.
 */

import { c } from '@/lib/utils';

/** Number of columns to collapse into the mobile summary cell */
export const MOBILE_SUMMARY_COLUMN_COUNT = 3;

/**
 * Maximum width percentage for each slot in row 2.
 * This ensures neither slot can dominate - each gets at most 60%,
 * guaranteeing the other slot at least 40% even with long content.
 */
export const MOBILE_SUMMARY_SLOT_MAX_WIDTH = c('max-w-[60%]');

/**
 * Padding to subtract from container width for summary cell sizing.
 * Accounts for table cell padding (p-2 = 8px * 2 sides = 16px).
 */
export const MOBILE_SUMMARY_CELL_PADDING = 16;

/** Debounce delay in ms for resize observer updates */
export const MOBILE_SUMMARY_RESIZE_DEBOUNCE_MS = 100;
